/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toggle_Prev_NextInputs */

const en_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Prev/Next Event View`)
};

const fr_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basculer la vue événement précédent/suivant`)
};

const de_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorherige/Nächste Ereignisansicht umschalten`)
};

const it_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la visualizzazione dell'evento precedente/successivo`)
};

const ru_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переключить просмотр предыдущего/следующего события`)
};

const es_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar vista de evento anterior/siguiente`)
};

const zh_cn2_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换上一个/下一个事件视图`)
};

const ja_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`前のイベント/次のイベントビューを切り替える`)
};

const hi_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पिछला/अगला इवेंट दृश्य टॉगल करें`)
};

const pt_pt2_toggle_prev_next = /** @type {(inputs: Toggle_Prev_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar visualização de eventos anterior/seguinte`)
};

/**
* | output |
* | --- |
* | "Toggle Prev/Next Event View" |
*
* @param {Toggle_Prev_NextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toggle_prev_next = /** @type {((inputs?: Toggle_Prev_NextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toggle_Prev_NextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_toggle_prev_next(inputs)
	if (locale === "de") return de_toggle_prev_next(inputs)
	if (locale === "it") return it_toggle_prev_next(inputs)
	if (locale === "ru") return ru_toggle_prev_next(inputs)
	if (locale === "es") return es_toggle_prev_next(inputs)
	if (locale === "zh-CN") return zh_cn2_toggle_prev_next(inputs)
	if (locale === "ja") return ja_toggle_prev_next(inputs)
	if (locale === "hi") return hi_toggle_prev_next(inputs)
	if (locale === "pt-PT") return pt_pt2_toggle_prev_next(inputs)
	return en_toggle_prev_next(inputs)
});